// extracted by mini-css-extract-plugin
module.exports = {"pillsGroup":"PillsGroup_pillsGroup__1S0Fw","select":"PillsGroup_select__3EmGP","ommitedValues":"PillsGroup_ommitedValues__2RlyF","edit":"PillsGroup_edit__2ewkx"};